import { useNavigate } from 'react-router-dom';

export const fetchWithAuth = async (url, options = {}, dispatch) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    
    if (user?.token) {
      options.headers = {
        ...options.headers,
        'Authorization': `Bearer ${user.token}`
      };
    }

    const response = await fetch(url, options);
    
    if (!response.ok) {
      const error = await response.json();
      if (response.status === 401) {
        handleTokenError(error, dispatch);
      }
      throw error;
    }

    return response;
  } catch (error) {
    if (isTokenError(error)) {
      handleTokenError(error, dispatch);
    }
    throw error;
  }
};

export const handleTokenError = (error, dispatch) => {
  // Clear invalid token from storage
  localStorage.removeItem('user');
  
  // Update auth context
  dispatch({ type: 'LOGOUT' });
  
  // Redirect to home
  window.location.href = '/';
};

// Utility to check if response indicates token error
export const isTokenError = (error) => {
  return error?.message?.includes('invalid token') || 
         error?.message?.includes('Token validation') ||
         error?.status === 401;
};
